import { cn } from "@msuite/ui/utils";
import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import { useAbsencesCalendarContext } from "./context";

interface AbsencesCalendarRowWrapperProps extends PropsWithChildren {
	variant: "header" | "content";
}

export function AbsencesCalendarRowWrapper({
	children,
	variant = "content",
}: AbsencesCalendarRowWrapperProps) {
	const { controller } = useAbsencesCalendarContext();
	const { columns, constants } = controller;

	/** Memoized */
	const style = useMemo(
		() => ({
			gridTemplateColumns: `${constants.FIRST_COLUMN_WIDTH} repeat(${columns}, minmax(0, 1fr))`,
			gridAutoRows: "1fr",
		}),
		[columns, constants.FIRST_COLUMN_WIDTH],
	);

	/** Render */
	return (
		<div
			className={cn(
				"grid",
				"border-b-[0.5px] border-color",
				"*:border-r-[0.5px] *:border-color *:p-2",
				"min-h-10",
				"items-center",
				`absences-calendar-row-${variant}`,
			)}
			style={style}
		>
			{children}
		</div>
	);
}
